import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col w-full h-full gap-y-2" };
const _hoisted_2 = { class: "border-b border-eblack-300" };
const _hoisted_3 = { class: "flex flex-wrap -mb-px text-sm font-medium text-center text-eblack-950 bg-eblack-100/70 rounded-t-md pt-0.5 px-0.5" };
const _hoisted_4 = { class: "me-2" };
const _hoisted_5 = {
    key: 0,
    class: "me-2"
};
import { ref, watch } from "vue";
import FormTab from "./FormTab.vue";
import ItinerariesTab from "./ItinerariesTab.vue";
// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerForm',
    props: {
        customer: {},
        closeModal: { type: Function },
        loadData: { type: Function },
        viewClicked: { type: Boolean },
        overlayService: {}
    },
    setup(__props) {
        const props = __props;
        // ---------------------------------------------------------------------------
        // State
        // ---------------------------------------------------------------------------
        const tab = ref(1);
        // Reset to "Formulario" tab whenever a different customer is loaded
        watch(() => props.customer, () => {
            tab.value = 1;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("ul", _hoisted_3, [
                        _createElementVNode("li", _hoisted_4, [
                            _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = ($event) => (tab.value = 1)),
                                class: _normalizeClass([
                                    tab.value === 1
                                        ? 'bg-white border-b border-eorange-300'
                                        : 'border-transparent',
                                    "inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group"
                                ])
                            }, [
                                _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                    class: "w-4 h-4 text-gray-400 me-2 group-hover:text-gray-500",
                                    "aria-hidden": "true",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "currentColor",
                                    viewBox: "0 0 18 20"
                                }, [
                                    _createElementVNode("path", { d: "M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" })
                                ], -1)),
                                _createTextVNode(_toDisplayString(_ctx.$t("customer.auto.formulario")), 1)
                            ], 2)
                        ]),
                        (__props.viewClicked)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (tab.value = 2)),
                                    class: _normalizeClass([
                                        tab.value === 2
                                            ? 'bg-white border-b border-eorange-300'
                                            : 'border-transparent',
                                        "inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group"
                                    ])
                                }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                        class: "w-4 h-4 text-gray-400 me-2 group-hover:text-gray-500",
                                        "aria-hidden": "true",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24"
                                    }, [
                                        _createElementVNode("path", {
                                            "fill-rule": "evenodd",
                                            d: "M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857ZM18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z",
                                            "clip-rule": "evenodd"
                                        })
                                    ], -1)),
                                    _createTextVNode(_toDisplayString(_ctx.$t("customer.auto.servicios_contratados")), 1)
                                ], 2)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (tab.value === 1)
                    ? (_openBlock(), _createBlock(FormTab, {
                        key: 0,
                        customer: __props.customer,
                        "close-modal": __props.closeModal,
                        "init-data": __props.loadData,
                        viewClicked: __props.viewClicked,
                        overlayService: __props.overlayService
                    }, null, 8, ["customer", "close-modal", "init-data", "viewClicked", "overlayService"]))
                    : _createCommentVNode("", true),
                (tab.value === 2)
                    ? (_openBlock(), _createBlock(ItinerariesTab, {
                        key: 1,
                        customerId: __props.customer?.id ?? 0
                    }, null, 8, ["customerId"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
